module.exports = __webpack_public_path__ + "site-127.jpg?2dfc639d86a45925176b76cc74469d1f";


/*****************
 ** WEBPACK FOOTER
 ** ./src/assets/portfolio/site-127.jpg
 ** module id = 105
 ** module chunks = 0
 **/